import type { IGtmPush } from './gtm';
import type { Component } from 'vue';

export enum EModalName {
  login = 'login',
  signup = 'signup',
  restricted_signup = 'restricted_signup',
  forgot = 'forgot',
  reset_password = 'reset_password',
  unlock = 'unlock',
  deposit = 'deposit',
  deposit_currencies = 'deposit_currencies',
  confirm = 'confirm',
  unlock_result = 'unlock_result',
  freespins = 'freespins',
  bonuses = 'bonuses',
  level_up = 'level_up',
  notification = 'notification',
  welcome = 'welcome',
  cashier = 'cashier',
  compoints = 'compoints',
  race = 'race',
  bonus_promo = 'bonus_promo',
  cooling_off_period = 'cooling_off_period',
  withdraw = 'withdraw',
  confirm_signup = 'confirm_signup',
  confirm_cross_sales = 'confirm_cross_sales',
  buy_crypto = 'buy_crypto',
  search = 'search',
  fiat_currencies = 'fiat_currencies',
  estonian = 'estonian',
  freespin_games = 'freespin_games',
  before_cancel_bonus = 'before_cancel_bonus',
  pwa_install = 'pwa_install',
  wheel_win = 'wheel_win',
  documents_upload_guide = 'documents_upload_guide',
  self_exclusion = 'self_exclusion',
  set_limits = 'set_limits',
  change_session_limit = 'change_session_limit',
  two_factory_backup_codes = 'two_factory_backup_codes',
}

export interface IModalParams {
  modal?: EModalName;
  closeAll?: boolean;
  redirect?: boolean;
  gtmParams?: Partial<IGtmPush>;
  doNotAttachToQuery?: boolean;
  [key: string]: any;
}

export interface IModalSelectorTab {
  title: string;
  componentName: EModalName;
}

export interface IModalComponent {
  // eslint-disable-next-line @typescript-eslint/consistent-type-imports
  component: Promise<typeof import('*.vue')>;
  loading: Component;
}
